interface RiskGroupOption {
  id: string
}

/**
 * The risk group to price Security quotes with, or null when it is missing
 * or not one of the caller's. SORM answers an unknown risk group with an empty
 * book rather than an error, so callers must not query without a valid one.
 */
export function validRiskGroupId(
  riskGroupId: string | null | undefined,
  riskGroups: ReadonlyArray<RiskGroupOption>,
): string | null {
  if (!riskGroupId) return null
  return riskGroups.some((group) => group.id === riskGroupId)
    ? riskGroupId
    : null
}
